import { createFileRoute } from '@tanstack/react-router'
import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { z } from 'zod'
import { Card } from '@/components/ui/card'
import { Button } from '@/components/custom/button'
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form'
import { Input } from '@/components/ui/input'

export const Route = createFileRoute('/_public/forgot-password')({
  component: ForgotPassword,
})

const formSchema = z.object({
  email: z
    .string()
    .min(1, { message: 'Email không được bỏ trống' })
    .email({ message: 'Email không hợp lệ' }),
})

export default function ForgotPassword() {
  const form = useForm({
    resolver: zodResolver(formSchema),
    defaultValues: {
      email: '',
    },
  })
  const onSubmit = () => {}
  return (
    <>
      <div className="container grid h-svh max-w-none flex-col items-center justify-center bg-primary-foreground px-0">
        <div className="mx-auto flex w-[480px] flex-col justify-center space-y-2 p-8">
          <div className="mb-4 flex items-center justify-center">
            <h1 className="text-xl font-medium">Zenify</h1>
          </div>
          <Card className="p-6">
            <div className="mb-2 flex flex-col space-y-2 text-left">
              <h1 className="text-md font-semibold tracking-tight">
                Quên mật khẩu
              </h1>
              <p className="text-sm text-muted-foreground">
                Nhập email của bạn để xác minh, chúng tôi sẽ gửi mã gồm 4
                chữ số đến email của bạn.
              </p>
            </div>
            <div className="grid gap-6">
              <Form {...form}>
                <form onSubmit={form.handleSubmit(onSubmit)}>
                  <div className="grid gap-2">
                    <FormField
                      control={form.control}
                      name="email"
                      render={({ field }) => (
                        <FormItem className="space-y-1">
                          <FormLabel>Email</FormLabel>
                          <FormControl>
                            <Input placeholder="name@example.com" {...field} />
                          </FormControl>
                          <FormMessage />
                        </FormItem>
                      )}
                    />
                    <Button className="mt-2">Tiếp tục</Button>
                  </div>
                </form>
              </Form>
            </div>
          </Card>
        </div>
      </div>
    </>
  )
}
